
















































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AboutUsVisionary extends Vue {
  @Prop(Number) index!: number;
  @Prop(String) title!: string;
  @Prop(String) text!: string;
  @Prop(String) imgSrc!: string;
  @Prop(Boolean) reverse!: boolean;

  get rowClass() {
    return this.reversed ? 'flex-row-reverse' : '';
  }

  get reversed() {
    return this.reverse && this.$vuetify.breakpoint.mdAndUp;
  }

  onImgLoad() {
    this.$lax.addElements(`#visionary-image-${this.index}.lax`, {
      scrollY: {
        translateY: [
          ['elInY', 'elCenterY+100'],
          ['-elHeight/5', 0],
        ],
      },
    });
  }

  destroyed() {
    this.$lax.removeElements(`#visionary-image-${this.index}.lax`);
  }
}
